/**
 * Home page component for Stack Forward website
 */

import React from 'react';
import { Header } from './Header';
import { Hero } from './Hero';
import { Logos } from './Logos';
import { Features } from './Features';
import { UseCases } from './UseCases';
import { CTA } from './CTA';
import { ContactForm } from './ContactForm';
import { Footer } from './Footer';

/**
 * HomePage component that composes all main sections
 */
export const HomePage: React.FC = () => {
  return (
    <>
      {/* Header */}
      <Header />

      {/* Main content */}
      <main>
        {/* Hero section */}
        <Hero />

        {/* Logos section */}
        <Logos />

        {/* Features/Solutions section */}
        <Features />

        {/* Use Cases section */}
        <UseCases />

        {/* CTA section */}
        <CTA />

        {/* Contact form section */}
        <ContactForm />
      </main>

      {/* Footer */}
      <Footer />
    </>
  );
};
